import Select2 from 'select2';

$(function() {
  $('.select2').select2({
    width: '100%'
  });
});
